import { isClient } from '~/config/public/environment';
import { SubscriptionType } from '../interfaces/EmailSubscription';
import { VehicleType } from '../interfaces/ProcessObject';

type CreateEmailSubscriptionNames = {
  personalCarSubscription: boolean;
  heavyVehiclesSubscription: boolean;
  corporateSubscription?: boolean;
  carDealerSubscription?: boolean;
};

export function createEmailSubscriptionNames({
  personalCarSubscription,
  heavyVehiclesSubscription,
  corporateSubscription,
  carDealerSubscription
}: CreateEmailSubscriptionNames) {
  const emailSubscriptionNames: SubscriptionType[] = [];

  personalCarSubscription &&
    emailSubscriptionNames.push(SubscriptionType.WeeklyPersonalCar);
  heavyVehiclesSubscription &&
    emailSubscriptionNames.push(SubscriptionType.WeeklyHeavyVehicles);
  corporateSubscription &&
    emailSubscriptionNames.push(SubscriptionType.Corporate);
  carDealerSubscription &&
    emailSubscriptionNames.push(SubscriptionType.CarDealer);

  return emailSubscriptionNames;
}

export const getSessionStorage = (key: string): string => {
  if (isClient) return sessionStorage.getItem(key) ?? '';
  return '';
};

export function getMainCategoryFromVehicleType(vehicleType: VehicleType) {
  if (
    vehicleType === VehicleType.HeavyTransport ||
    vehicleType === VehicleType.Machines
  )
    return 'transport_and_machinery';

  return vehicleType?.toLowerCase();
}
